import { useNavigate, useParams } from "react-router-dom";
import { adaptItem } from "datasets/pages/dashboards/hooks/useDatasetDashboards";
import Dashboard from "datasets/pages/dashboards/types/interfaces/dashboard";
import { KeyedMutator, SWRResponse } from "swr";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";
import { V1DashboardResult } from "~/types/interfaces/catalogDashboards";

const { VITE_CATALOG_API } = import.meta.env;

const useReport = (): SWRResponse<Dashboard> => {
  const navigate = useNavigate();
  const { datasetId, reportId } = useParams();

  const resp = useFetcher<V1DashboardResult>(
    datasetId && reportId
      ? `${VITE_CATALOG_API}/v1/datasets/${datasetId}/dashboards/${reportId}`
      : null
  );

  if (resp.error?.status >= 400 && resp.error.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return {
    ...resp,
    data: resp.data ? adaptItem(resp.data) : undefined,
    mutate: resp.mutate as KeyedMutator<any>,
  } as SWRResponse<Dashboard>;
};

export default useReport;
